import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5cdde582")

_pushScopeId("data-v-5cdde582")
const _hoisted_1 = {
  key: 0,
  class: "toc_ui__loopCarVideo_main"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetectPlayer = _resolveComponent("DetectPlayer")

  return (_ctx.state.videoId)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_DetectPlayer, {
          vid: _ctx.state.videoId,
          class: "DetectPlayer",
          "play-data": _ctx.state.playData
        }, null, 8, ["vid", "play-data"])
      ]))
    : _createCommentVNode("", true)
})